import { mobileToolbarActions } from "Dashboard/components/WhatsNext/actions";
import {
  useActiveAction,
  useDrawingActions,
} from "Dashboard/components/WhatsNext/whatsNextStore";
import { useEffectiveIsExpanded, useIsFullScreen } from "NavBar/stateHooks";

const useIsFlashing = () => {
  const [isExpanded] = useEffectiveIsExpanded();
  const isFullScreen = useIsFullScreen();
  const [activeAction] = useActiveAction();
  const drawingActions = useDrawingActions();

  if (isExpanded) return false;
  if (!drawingActions.has(activeAction)) return false;

  // On mobile, actions in mobileToolbarActions have their target buttons visible
  // in the FloatingToolbar — those buttons flash on their own, so the expand
  // button should not flash for them.
  if (isFullScreen && mobileToolbarActions.includes(activeAction)) return false;

  return true;
};

export default useIsFlashing;
